import React, { useCallback } from 'react'
import { CheckOutlined } from '@ant-design/icons'
import { Popconfirm, Tooltip } from 'antd'
import PropTypes from 'prop-types'

import { StyledButtonWithMargin } from '../../../common/components/styled'

import { useUpdatePriorityTaskMutation } from '../../hooks'

const PriorityTaskDoneButton = ({ taskId, isDone }) => {
  const [update] = useUpdatePriorityTaskMutation()

  const handleDone = useCallback(() => {
    update(taskId, { isDone: true })
  }, [taskId, update])

  if (isDone) {
    return null
  }

  return (
    <Popconfirm
      title="This action is irreversible. Are you sure you want to mark this priority task as done?"
      onConfirm={handleDone}
    >
      <Tooltip title="Mark as done">
        <StyledButtonWithMargin icon={<CheckOutlined />} />
      </Tooltip>
    </Popconfirm>
  )
}

PriorityTaskDoneButton.propTypes = {
  taskId: PropTypes.string.isRequired,
  isDone: PropTypes.bool.isRequired,
}

export default PriorityTaskDoneButton
